import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

/**
 * @purpose Maintain the materials catalog and its prices
 * @primary Materials table
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/materials/")({
  validateSearch: listSearch,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
